<ng-container *ngIf="assignedSuccess">
    <app-assigned-givi [isGiver]="giftcard?.type == 2" (close)="onCloseSucess()"></app-assigned-givi>
</ng-container>
<div class="text-center">
    <p *ngIf="requireVerification && (transactionIssue?.customerCard?.idImageURL == null || transactionIssue?.customerCard?.cardImageURL == null)" class="text-center m-b-20">
        ⚠️ Para realizar más compras, ingresá 
        <a (click)="verifyCard()" class="text-purple font-b2">aquí</a>
        e iniciá el proceso de validación ⚠️
    </p>

    <p *ngIf="requireVerification && (transactionIssue?.customerCard?.idImageURL != null || transactionIssue?.customerCard?.cardImageURL != null)" class="text-center m-b-20">
        Pronto vas a poder utilizar tu Givi, por seguridad necesitamos validar la autenticidad de la compra realizada anteriormente
    </p>

    <button class="btn btn-dark btn-wxl" style="padding: 10px 40px; border-radius: 25px;" (click)="onOpen()" [disabled]="requireVerification">Comprar</button>
</div>


<ng-template #purchaseModal let-modal>

    <div class="modal-header">
        <div class="d-flex w-100">
            <div class="cursor-pointer" (click)="modal.dismiss()" style="z-index: 1;">
                <i class="mdi mdi-arrow-left mdi-24px"></i>
            </div>
            <div class="text-center w-100 m-l-10 font-h6" style="margin-left: -24px;">
                Resumen de la orden
            </div>
        </div>
    </div>

    <div class="modal-body" style="max-height: fit-content;">
        <!-- Summary -->
        <div>

            <!-- Points -->
            <div class="border-bottom p-t-20 p-b-20">
                <div class="d-flex flex-row justify-content-between">
                    <!--Product Name-->
                    <div class="d-flex flex-row">
                        <img *ngIf="giftcard.mainUrl" [src]="giftcard.mainUrl" class="image-size" onError="this.src='assets/images/noimage.png'">
                        <img *ngIf="!giftcard.mainUrl" [src]="giftcard.mainUrl" class="image-size" onError="this.src='assets/images/noimage.png'">
                        <div class="m-l-10">
                            <div class="font-bold">
                                {{giftcard.quantitySelected}}x ({{giftcard.price | currency: giftcard?.currencySymbol : 'symbol': '1.0'}})
                            </div>
                            <div class="p-giftcard-name">
                                {{giftcard.name}}
                            </div>
                            <div class="font-bold">
                                {{giftcard.priceTotal | currency: giftcard?.currencySymbol : 'symbol': '1.0'}}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- SubTotal -->
            <div *ngIf="user.availablePoints" class="border-bottom p-t-20 p-b-20">
                <!-- SubTotal -->
                <div class="d-flex flex-row justify-content-between">
                    <div class="font-14">
                        Subtotal
                    </div>
                    <div class="font-14">
                        {{model.subTotal | currency: model?.currencySymbol : 'symbol': '1.0'}}
                    </div>
                </div>
                <!-- Total -->
                <div class="d-flex flex-row justify-content-between">
                    <div class="font-14">
                        Descuento puntos
                    </div>
                    <div class="font-14">
                        {{model.pointsDiscount | currency: model?.currencySymbol : 'symbol': '1.0'}}
                    </div>
                </div>
            </div>

            <!-- Tax -->
            <div *ngIf="model.customerCommissionPercent > 0" class="border-bottom p-t-20 p-b-20">
                <div class="d-flex flex-row justify-content-between">
                    <div class="font-14">
                        Costo por servicio {{model.customerCommissionPercent }}% 
                        <i class="mdi mdi-information text-primary cursor-pointer ml-2 custom-icon" [ngbPopover]="popContent"  container="body"></i>
                    </div>
                    <ng-template #popContent>
                        <b>Tarifa porcentual</b><br>
                        <ul>
                            <li>Costos gubernamentales</li>
                            <li>Costos marcas de tarjetas (Visa, Mastercard, Amex)</li>
                            <li>Costos de proveedor de procesamiento de pagos</li>
                            <li>Costos Bancarios</li>
                          </ul>
                        <b>Comisión Givi</b>
                    </ng-template>
                    <div class="font-14">
                        {{model.customerCommission| currency: model?.currencySymbol : 'symbol': '1.0'}}
                    </div>
                </div>
            </div>           

            <!-- Totals -->
            <div class="border-bottom p-t-20 p-b-20">
                <!-- Total -->
                <div class="d-flex flex-row justify-content-between">
                    <div class="font-bold">
                        Total
                    </div>
                    <div class="font-bold">
                        {{model.total + model.customerCommission | currency: model?.currencySymbol : 'symbol': '1.0'}}
                    </div>
                </div>
            </div>

            <div class="bg-dark m-t-20 m-b-20 d-flex justify-content-center align-items-center" style="height: 40px; border-radius: 5px;">
                <div class="text-center w-100 font-b2 text-white" style="margin-right: -24px;">
                    Métodos de pago
                </div>
            </div>

            <!-- Aplicar Puntos,  1 == pointsAccordion-->
            <!-- <div class="p-b-10" (click)="onToggleAccordion(1)">
                <div class="d-flex flex-row justify-content-between bg-light rounded p-3">
                    <div class="text-left">
                        <img class="m-5-5 p-r-10" src="assets/images/givi-cash-logo.png" width="36">

                        <span class="font-bold font-12">
                            Aplicar puntos a mi compra
                        </span>
                    </div>

                    <span class="font-bold font-18" [ngStyle]="{'transform': pointsAccordion ? 'rotate(90deg)' : 'none'}">
                        >
                    </span>
                </div>
            </div>
            !-- Abre acordeon --
            <div *ngIf="pointsAccordion" class="m-t-20">
                <div *ngIf="user.availablePoints" class="m-t-20">
                    <app-purchase-with-points-modal [user]="user" [model]="model" (sendPointsSelected)="onReceivePointsSelected($event)"
                        [pointsSelected]="model.points"></app-purchase-with-points-modal>
                </div>
                <div *ngIf="!user.availablePoints" class="m-b-20">
                    <div class="mx-auto text-center">
                        <div class="font-bold">
                            <div class="font-12 font-bold">
                                "No tenés puntos disponibles."
                                <br>
                                <a href="javascript:void(0)" (click)="onShowGetPoints()">Ver cómo puedo conseguir puntos</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div> -->

            <!-- Tarjeta -->
            <!-- 2 == paymentMethodAccordion -->
            <div *ngIf="currentMethod" class="p-b-20 cursor-pointer" (click)="onToggleAccordion(2)">

                <div class="d-flex flex-row justify-content-between bg-light rounded p-3">
                    <!-- LOGO -->
                    <div class="text-left">
                        <img class="m-5-5 p-r-10" src="{{currentMethod.logoURL}}" width="36">

                        <span class="font-bold font-12">
                            {{currentMethod?.name ? currentMethod?.name : '**** **** ****' }} {{currentMethod.masked}}
                        </span>
                    </div>

                    <span class="font-bold font-18" [ngStyle]="{'transform': paymentMethodAccordion ? 'rotate(90deg)' : 'none'}">
                        >
                    </span>
                </div>
            </div>
            <!-- Opciones de pago, acordeon-->
            <div *ngIf="paymentMethodAccordion" class="m-t-20">
                <div class="border-bottom">
                    <div class="text-center">
                        <i class="mdi mdi-credit-card-multiple mdi-24px"></i>
                    </div>
                    <div class="text-center m-b-20">
                        Opciones de pago
                    </div>
                </div>

                <!-- Tarjeta -->
                <div *ngFor="let sourceItem of methods">
                    <div class="border-bottom p-20 cursor-pointer" (click)="onSelectMethod(sourceItem, 2)">

                        <div class="d-flex flex-row justify-content-between">
                            <!-- LOGO -->
                            <div class="text-left">
                                <img class="m-5-5" src="{{sourceItem.logoURL}}" width="36">

                                <span class="font-bold font-10">
                                    {{sourceItem?.name ? sourceItem?.name : '**** **** ****' }} {{sourceItem.masked}}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Agregar tarjeta -->
            <div class="p-b-10 comment-row" (click)="onCreateCard(addPaymentMethodModal)">
                <div class="d-flex content-label-card text-center">
                    <div class="m-l-10 m-t-8">
                        <i class="mdi mdi-plus-circle-outline mdi-36px m-r-16"></i>
                    </div>
                    <div>
                        <label class="fond-card" style="margin-top: 16px;">
                            Agregar nueva tarjeta
                        </label>
                    </div>
                </div>
            </div>

            <!-- button submit -->
            <div class="d-flex-center p-20">
                <button [disabled]="!(model && currentMethod)" class="btn btn-dark btn-wxl" style="padding: 10px 40px; border-radius: 25px;" (click)="onPay()">Pagar</button>
            </div>
        </div>
    </div>
</ng-template>


<!-- Opciones de pago NO FUNCIONAL POR EL ACORDEON -->
<ng-template #paymentMethodModal let-modal>
    <div class="modal-body">

        <div>
            <button class="close" (click)="modal.dismiss()">
                <i class="fa fa-times m-t-5 m-r-10"></i>
            </button>
        </div>

        <div class="border-bottom">
            <div class="text-center">
                <i class="mdi mdi-credit-card-multiple mdi-24px"></i>
            </div>
            <div class="text-center m-b-20">
                Opciones de pago
            </div>
        </div>

        <!-- Tarjeta -->
        <div *ngFor="let sourceItem of methods">
            <div class="border-bottom p-20 cursor-pointer" (click)="onSelectMethod(sourceItem, modal)">

                <div class="d-flex flex-row justify-content-between">
                    <!-- LOGO -->
                    <div class="text-left">
                        <img class="m-5-5" src="{{sourceItem.logoURL}}" width="36">

                        <span class="font-bold font-10">
                            {{sourceItem?.name ? sourceItem?.name : '**** **** ****' }} {{sourceItem.masked}}
                        </span>
                    </div>

                    <span class="font-bold font-18">
                        >
                    </span>
                </div>
            </div>
        </div>

        <!-- Agregar tarjeta -->
        <div class="p-20">
            <div class="p-b-10 comment-row" (click)="onCreateCard(addPaymentMethodModal)">
                <div class="d-flex content-label-card text-center">
                    <div class="m-l-20 m-t-8">
                        <i class="mdi mdi-plus-circle-outline mdi-36px m-r-16"></i>
                    </div>
                    <div>
                        <label class="fond-card" style="margin-top: 16px;">
                            Agregar nueva tarjeta
                        </label>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-template>


<!-- Agregar nueva tarjeta -->
<ng-template #addPaymentMethodModal let-modal>
    <div class="modal-body" style="border-radius: 20px 20px 0px 0px;">

        <div>
            <button class="close" (click)="modal.dismiss()">
                <i class="fa fa-times m-t-5 m-r-10"></i>
            </button>
        </div>

        <div class="m-b-20 border-bottom">
            <div class="text-center">
                <i class="mdi mdi-credit-card-plus mdi-24px"></i>
            </div>
            <div class="text-center m-b-20">
                Agregar nueva tarjeta
            </div>
        </div>

        <!-- Formulario de tarjeta compartido: decide solo si muestra los campos de
             ONVO o los de Stripe según la pasarela del país -->
        <div class="m-b-20 p-20">
            <app-card-form [country]="country" (cardChange)="onCardChange($event)"></app-card-form>

            <div>
                <img src="assets/images/masterVisaStripe.png" height="28">
            </div>
        </div>

        <div class="d-flex-center">
            <button [disabled]="readonly || !newCard" (click)="onSaveCard(modal)"
                class="btn btn-primary btn-sm m-2">Agregar</button>
        </div>
    </div>
</ng-template>

<app-get-points-modal></app-get-points-modal>

<!-- VerifyCard -->
<app-verify-card [issueTypes]="issueTypes"></app-verify-card>
